import { render } from "./QRReaderComponent.vue?vue&type=template&id=2e55c5ec"
import script from "./QRReaderComponent.vue?vue&type=script&lang=js"
export * from "./QRReaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__